<template>
    <div v-if="getPermission.settings.view || getPermission.masterdata.view"> 
    <!--
    <driver-form ref="DriverFormCreate" 
      mode="CREATE"/>
    -->
    <driver-form ref="DriverFormCreate"
      mode="CREATE"/>
    <driver-form ref="DriverFormUpdate"
      mode="UPDATE"/>  
    <driver-form ref="DriverFormInboundCreate"
      mode="INBOUNDCREATE"/>
    <driver-form ref="DriverFormInboundUpdate"
      mode="INBOUNDUPDATE"/>  
    <driver-form ref="DriverFormShowLicExp"
      mode="LICEXPHIST"/>  

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div  v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
                <md-field>
                  <label id="label_ShortId">Driver Name</label>
                  <md-input id="shortId" ref="shortId" v-model="searchRequest.shortId"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
             <div class = "inputBox">
                <md-field>
                  <label id="label_Mobile">Driver Mobile</label>
                  <md-input id="driverMobile" ref="driverMobile" v-model="searchRequest.driverMobile"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
             <div class = "inputBox">
                <md-field>
                  <label id="label_Trailer">Trailer Num</label>
                  <md-input id="trailerNum" ref="trailerNum" v-model="searchRequest.trailernum"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
              <auto-complete-master-data-select
                          label="Sales Office"
                          display-type="idOnly"
                          :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_SALEOFFICE')"
                          :init-value-id="searchRequest.defaultSalesOffice"
                          :on-item-changed="handleDefaultSalesOfficeChanged">
              </auto-complete-master-data-select>
            </div>
          </div>


          <div v-if="getPermission.ccic.edit || getPermission.masterdata.edit" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/gstMasterData/driverMasterData', '/api/w/gstMasterData/updateDriver']">
              <callingApiCenter path=" /api/w/gstMasterData/driverMasterData" :not-display-error="true">
                  <md-button class="md-raised custButton " @click="doNew" :disabled="getPermission.stcAuditOnly.view" ><span class="icons-center material-icons">create</span>New</md-button>
                  <md-button id = "searchTag"  @click="doSearch" class=" custButton btn-search-master-form-driver md-primary md-raised">Search</md-button>
                  <md-button   class="md-raised custButton" @click="doClear">Clear</md-button>
             <input class = "custSearchBar" type="text"
                    placeholder="Searching Term"
                    v-model="filter"
                    />
            <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>

        <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">

              <div class="table-header" v-if="getPermission.settings.edit">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                  </tr>
                  <th class="header-cell w2"></th>
                    <th class="header-cell center w5" >Drive No.</th>
                    <th class="header-cell center w5" >Short ID</th>
                    <th class="header-cell center w10" >Driver Company</th>
                    <th class="header-cell center w5" >Default Sales Office</th>
                    <th class="header-cell center w5" >Default Plate (Truck No)</th>
                    <th class="header-cell center w5" >Address-City</th>
                    <th class="header-cell center w5" >Address-State</th>
                    <th class="header-cell center w5" >Address-Post Code</th>
                    <th class="header-cell center w5" >Telephone</th>
                    <th class="header-cell center w5" >Mobile</th>
                    <th class="header-cell center w5" >Hiring Start Date</th>
                    <th class="header-cell center w5" >Termination Date</th>
                    <th class="header-cell center w5" >License</th>
                    <th class="header-cell center w5" >License Exp Date</th>
                    <th class="header-cell center w5" >DMV Record Type</th>
                    <th class="header-cell center w5" >DMV Notification mail out date</th>
                    <th class="header-cell center w5" >MED Exp. Date</th>
                    <th class="header-cell center w5" >Drug Test Exp. Date</th>
                    <th class="header-cell center w5" >Insurance Exp. Date</th>
                    <th class="header-cell center w5" >Trailer Num</th>
                    <th class="header-cell center w5" >Created</th>
                    <th class="header-cell center w5" >Created Date</th>
                    <th class="header-cell center w5" >Update</th>
                    <th class="header-cell center w5" >Update Date</th>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll" v-if="getPermission.settings.edit">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vuekey" v-for="item in pageItems">
                     <td class="body-cell w2 ">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                    </td>
                    <td class="body-cell excelBox w5">{{item.driverId}}</td>
                    <td class="body-cell excelBox w5">{{item.shortId}}</td>
                    <td class="body-cell excelBox w10">{{item.driverCompany}}</td>
                    <td class="body-cell excelBox w5">{{item.defaultSalesOffice}}</td>
                    <td class="body-cell excelBox w5">{{item.defaultPlateNum}}</td>
                    <td class="body-cell excelBox w5">{{item.driverCity}}</td>
                    <td class="body-cell excelBox w5">{{item.driverState}}</td>
                    <td class="body-cell excelBox w5">{{item.postal}}</td>
                    <td class="body-cell excelBox w5">{{item.driverTel}}</td>
                    <td class="body-cell excelBox w5">{{item.driverMobile}}</td>
                    <td class="body-cell excelBox w5">{{item.hiringStartDate }}</td>
                    <td class="body-cell excelBox w5">{{item.terminationDate}}</td>
                    <td class="body-cell excelBox w5">{{item.licenseNum}}</td>
                    <td class="body-cell excelBox w5" @click="showLicExpHist(item)">{{item.licenseExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.dmvRecType}}</td>
                    <td class="body-cell excelBox w5">{{item.dmvNotifMailOutDate}}</td>
                    <td class="body-cell excelBox w5">{{item.medExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.drugTestExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.insExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.trailernum}}</td>
                    <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                    <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                    <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                    <td class="body-cell excelBox w5">{{item.updateAt | date}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-header" v-if="getPermission.masterdata.edit">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                  </tr>
                  <th class="header-cell w2"></th>
                  <!--
                    <th class="header-cell center w5" >Drive No.</th>
                  -->  
                    <th class="header-cell center w5" >Short ID</th>
                  <!--  
                    <th class="header-cell center w5" >Default Sales Office</th>
                  -->  
                    <th class="header-cell center w5" >Default Plate (Truck No)</th>
                   <!-- 
                    <th class="header-cell center w5" >Address-City</th>
                    <th class="header-cell center w5" >Address-State</th>
                    <th class="header-cell center w5" >Address-Post Code</th>
                    <th class="header-cell center w5" >Telephone</th>
                   --> 
                    <th class="header-cell center w5" >Mobile</th>
                   <!-- 
                    <th class="header-cell center w5" >Hiring Start Date</th>
                    <th class="header-cell center w5" >Termination Date</th>
                    <th class="header-cell center w5" >License</th>
                    <th class="header-cell center w5" >License Exp Date</th>
                    <th class="header-cell center w5" >DMV Record Type</th>
                    <th class="header-cell center w5" >DMV Notification mail out date</th>
                    <th class="header-cell center w5" >MED Exp. Date</th>
                    <th class="header-cell center w5" >Drug Test Exp. Date</th>
                    <th class="header-cell center w5" >Insurance Exp. Date</th>
                   --> 
                    <th class="header-cell center w5" >Trailer Num</th>
                   <!-- 
                    <th class="header-cell center w5" >Created</th>
                    <th class="header-cell center w5" >Created Date</th>
                    <th class="header-cell center w5" >Update</th>
                    <th class="header-cell center w5" >Update Date</th>
                   --> 
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll" v-if="getPermission.masterdata.edit">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vuekey" v-for="item in pageItems">
                     <td class="body-cell w2 ">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                    </td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.driverId}}</td>
                    -->
                    <td class="body-cell excelBox w5">{{item.shortId}}</td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.defaultSalesOffice}}</td>
                    -->
                    <td class="body-cell excelBox w5">{{item.defaultPlateNum}}</td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.driverCity}}</td>
                    <td class="body-cell excelBox w5">{{item.driverState}}</td>
                    <td class="body-cell excelBox w5">{{item.postal}}</td>
                    <td class="body-cell excelBox w5">{{item.driverTel}}</td>
                    -->
                    <td class="body-cell excelBox w5">{{item.driverMobile}}</td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.hiringStartDate }}</td>
                    <td class="body-cell excelBox w5">{{item.terminationDate}}</td>
                    <td class="body-cell excelBox w5">{{item.licenseNum}}</td>
                    <td class="body-cell excelBox w5" @click="showLicExpHist(item)">{{item.licenseExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.dmvRecType}}</td>
                    <td class="body-cell excelBox w5">{{item.dmvNotifMailOutDate}}</td>
                    <td class="body-cell excelBox w5">{{item.medExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.drugTestExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.insExpDate}}</td>
                    -->
                    <td class="body-cell excelBox w5">{{item.trailernum}}</td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                    <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                    <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                    -->
                  </tr>
                  </tbody>
                </table>
              </div>


            </div>
          </div>
        </md-card>
      </template>
    </pagination>
    </div>
</template>


<style scoped>


.excelBox {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
  
}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 5px 5px 5px 5px;
    margin-top: 5px;
}

.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 6px 6px 6px 6px;
    margin-top: 5px;
    background-color: #e0eff7;
      
}

.selected {
     background: #726a95;
}

.tableW {
    height: 40px;
}

.center {
    text-align: center;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}


.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}

.md-menu {
  padding: 0;
  padding: 0;

}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.8rem;
   
}

.custMenuButton {
    
    width: 110px;
    height: 40px;
    line-height:45px;
    font-size: 0.9rem;
    align-self: center;
   
}

.custSearchBar{
      margin: 10px;
    width: 200px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}


.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
}
</style>

<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  import api from "../api";
  import parseXls from "../utils/parseXls";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import DriverForm from '../components/DriverForm.vue';


    const getInitSearch = () => ({
    shortId: null,  
    defaultSalesOffice: "LGB",
    driverOffice: "FSI",
    //driverStatus: null,
    //driverType: null,
    driverMobile: null,
    trailernum: null,
  });

  export default {

    data: () => ({
      searchRequest: getInitSearch(),
      active: false,
      items: [],
      dialog: {
        isShowing: false,
      },
      usersToSearch: [],
      modalMessage: "",  
      isWarning: false,
      sortStatus: true,
      filter:"",
    }),


    components: {
      callingApiCenter,
      DriverForm,
    },

    watch: {
      getGSTDriverMaster(val) {
        this.updateItems(val);
      },
    },

    computed: {
    ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getGSTDriverMaster',
      ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(null).includes(term)
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canEdit() {
        return this.getSelectedItems.length === 1 ;
      },
    },

    async mounted() {
        const cachedSearchRequest = this.$store.state.gstDriverMaster.searchRequest;
        this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        this.searchRequest.driverOffice = "FSI";
        this.$el.querySelector('#searchTag').click();
        console.log("this.getGSTDriverMaster:" + this.getGSTDriverMaster);
        this.updateItems(this.getGSTDriverMaster);
    },

     methods: {
        mouseOver: function(){
            this.active = true;
        },

        mouseLeave: function() {
          this.active = !this.active;
        },

        updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
        },

        handleDriverStatusChanged(id) {
            this.searchRequest.driverStatus = id;
        },

        handleDriverTypeChanged(id) {
            this.searchRequest.driverType = id;
        },

        handleDefaultSalesOfficeChanged(id) {
            this.searchRequest.defaultSalesOffice = id;
        },

        doSearch() {
            //this.$store.dispatch('gstDriverMaster', this.searchRequest);
            //this.searchRequest.driverStatus;
            console.log("Driver master search driver name: " + this.searchRequest.shortId);
            console.log("search data: " + this.searchRequest.trailernum + " " + this.searchRequest.driverMobile)
            //this.searchRequest.defaultSalesOffice = "LGB"
            this.$store.dispatch('gstDriverMaster', this.searchRequest)
            //.filter(
            //   it => 
            //)
            //  .filter(it => (this.searchRequest.driverId === "100002"))
              ;
        },


        doClear(){
            _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
              .each((it) => {
                  console.log(it);
                  it.click();
              });
              this.$nextTick(() => {
              this.searchRequest = getInitSearch();
            });

        },

        handleScroll(e) {
            $(this.$el.querySelector('.table-header'))
            .offset({
                left: -1 * (e.target.scrollLeft - $('.outer-container')
                .offset().left),
            });
        },

        doNew() {
        var maxId = this.getMaxId(); 
        console.log('maxid:' + maxId);
        if (this.getPermission.settings.view)
            this.$refs.DriverFormCreate.openDialog(maxId);
        else
             this.$refs.DriverFormInboundCreate.openDialog(maxId);
        },

        toggleUpdate(item) {
        console.log("toggleUpdate:" + item.driverId);
        console.log("item selected value: " + item.selected);
        //console.log("item vuekey: " + item.vuekey);
        //if (item.selected)
        if (this.getPermission.settings.view)
           this.$refs.DriverFormUpdate.openDialog(item);
        else   
           this.$refs.DriverFormInboundUpdate.openDialog(item);
        },

        showLicExpHist(item) {
          console.log("show lic history");
          this.$refs.DriverFormShowLicExp.openDialog(item);
        },

        getMaxId() {
          return '100008';
        },

        includeNull(field){
                return field==null ? '' : field;
            },
        },

        getValidationClass(fieldName) {
           const field = _(this.$v)
            .lookup(fieldName);
           if (field) {
              return {
                 'md-invalid': field.$invalid && field.$dirty,
              };
           }
           return {};
        },

    }
</script>